import type { FC } from 'react';
import { Container, Content, InvaliadImage, Message, Wrapper } from './style';

const CheckBrowserPage: FC = () => {
  return (
    <Container>
      <Wrapper>
        <Content>
          <InvaliadImage src={'/img/invalid_page.png'} />
          <Message>
            현재 사용하고 계시는 브라우저에서는 서비스 이용이 불가능합니다.
            <br />
            화상면접 서비스는 Chrome에 최적화 되어있습니다.
          </Message>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default CheckBrowserPage;
